<template>
    <md-dialog
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            @keydown.esc="updateIsCreating"
            :md-active.sync="show_create_order">
        <md-toolbar>
            <div class="md-title md-layout md-gutter md-alignment-center-center" style="width: inherit">
                <div class="md-layout-item">
                    Create New Porting Order
                </div>
                <div class="md-layout md-alignment-center-right">
                    <md-button class="md-primary md-layout-item md-size-10"
                               @click="updateIsCreating"
                               :md-ripple="false">
                        <md-icon>close</md-icon>
                    </md-button>
                </div>
            </div>
        </md-toolbar>
        <md-dialog-content>
            <form novalidate class="md-layout" style="display: block">
                <md-card style="flex: 1">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Order details
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-size-40">
                                <el-tooltip :tabindex="-1" :disabled="pon_tooltip_disabled" content="Unique name for tracking this port request" placement="top" effect="light">
                                    <md-field id="name" :class="getValidationClass('name')">
                                        <label for="name">Port Order Name</label>
                                        <md-input :disabled="executing_add"
                                                  @focusin="pon_tooltip_disabled = true"
                                                  @focusout="pon_tooltip_disabled = false"
                                                  v-model="form.name"
                                                  name="name"
                                                  required></md-input>
                                        <span class="md-error"
                                              v-if="!$v.form.name.required">The order name is required</span>
                                        <span class="md-error" v-else-if="!$v.form.name.alpha_num_spaces">Should contain only alphanumeric characters and spaces</span>
                                    </md-field>
                                </el-tooltip>
                            </div>
                            <div class="md-layout-item md-size-40">
                                <el-tooltip  :tabindex="-1" :disabled="psne_tooltip_disabled" content="Account's email will be used if not provided" placement="top" effect="light">
                                    <md-field id="port_status_notification_email" :class="getValidationClass('port_status_notification_email')">
                                    <label for="port_status_notification_email">Port Status Notification Email</label>
                                    <md-input v-model="form.port_status_notification_email"
                                              :disabled="executing_add"
                                              @focusin="psne_tooltip_disabled = true"
                                              @focusout="psne_tooltip_disabled = false"
                                              name="port_status_notification_email"></md-input>
                                    <span class="md-error" v-if="!$v.form.port_status_notification_email.email">Should be a valid email</span>
                                </md-field>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-size-30">
                                <md-field id="entities" :class="getValidationClass('entity_id')">
                                    <label for="entities">Old Network Service Provider</label>
                                    <md-select v-model="form.entity_id"
                                               required
                                               :disabled="executing_add"
                                               name="entities">
                                        <md-option
                                                v-for="item in user.entity"
                                                v-bind:key="item.id"
                                                :value="item.id">
                                            {{ item.name }}
                                        </md-option>
                                    </md-select>
                                    <span class="md-error" v-if="!$v.form.entity_id.required">Old Network Service Provider is required</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-30">
                                <md-field id="new_entity_id" :class="getValidationClass('new_entity_id')">
                                    <label for="new_entity_id">New Network Service Provider</label>
                                    <md-input v-model="form.new_entity_id"
                                              :disabled="executing_add"
                                              name="new_entity_id"
                                              required
                                    ></md-input>
                                    <span class="md-error" v-if="!$v.form.new_entity_id.required">New Network Service Provider is required</span>
                                    <span class="md-error" v-else-if="!$v.form.new_entity_id.spid">Must consist of 3 digits followed by either a digit or a letter</span>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card style="flex: 1; margin-top: 10px">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Account details
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_name" :class="getValidationClass('customer_name')">
                                    <label for="customer_name">Customer Name</label>
                                    <md-input v-model="form.customer_name"
                                              :disabled="executing_add"
                                              name="customer_name"
                                              required
                                    ></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_name.required">The customer name is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_name.alpha_spaces">Should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <el-tooltip :tabindex="-1" :disabled="btn_tooltip_disabled" content="Main phone number associated with the account or the number to be ported" placement="top" effect="light">
                                    <md-field id="billing_telephone_number"

                                              :class="getValidationClass('billing_telephone_number')">
                                        <label for="billing_telephone_number">Billing telephone number</label>
                                        <md-input v-model="form.billing_telephone_number"
                                                  @focusin="btn_tooltip_disabled = true"
                                                  @focusout="btn_tooltip_disabled = false"
                                                  required
                                                  :disabled="executing_add"
                                                  name="billing_telephone_number"></md-input>
                                        <span class="md-error" v-if="!$v.form.billing_telephone_number.required">The billing telephone number is required</span>
                                        <span class="md-error" v-else-if="!$v.form.billing_telephone_number.phonenumber">Should be a phone number in E.164 format</span>
                                    </md-field>
                                </el-tooltip>
                            </div>
                                <md-field id="customer_country" class="md-layout-item md-size-30"
                                          style="margin-right: 20px"
                                          :class="getValidationClass('customer_country')"
                                          >
                                    <label for="customer_country">Customer Country</label>
                                    <md-select v-model="form.customer_country"
                                              required
                                              :disabled="executing_add"
                                              name="customer_country">
                                        <md-option
                                                v-for="item in countries" v-bind:key="item"
                                                :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                    <span class="md-error" v-if="!$v.form.customer_country.required">The customer country is required</span>
                                </md-field>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_street1" :class="getValidationClass('customer_street1')">
                                    <label for="customer_street1">Customer Street</label>
                                    <md-input v-model="form.customer_street1"
                                              required
                                              :disabled="executing_add"
                                              name="customer_street1"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_street1.required">The customer street is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_street1.alpha_num_spaces">Should contains only alphanumeric characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_street2" :class="getValidationClass('customer_street2')">
                                    <label for="customer_street2">Customer Street 2</label>
                                    <md-input v-model="form.customer_street2"
                                              :disabled="executing_add"
                                              name="customer_street1"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_street2.customer_street2">Should contains only alphanumeric characters and spaces</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field id="customer_city" required :class="getValidationClass('customer_city')">
                                    <label for="customer_city">Customer City</label>
                                    <md-input v-model="form.customer_city"
                                              name="customer_city"
                                              :disabled="executing_add"
                                              required
                                    ></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_city.required">The customer city is required</span>
                                    <span class="md-error" v-else-if="!$v.form.customer_city.alpha_spaces">Should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_state" :class="getValidationClass('customer_state')">
                                    <label for="customer_state">Customer State</label>
                                    <md-input v-model="form.customer_state"
                                              :required="form.customer_country === 'United States'"
                                              :disabled="executing_add"
                                              name="customer_state"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_state.customer_state">Required and should contains only alphabet characters and spaces</span>
                                </md-field>
                            </div>
                            <div class="md-layout-item">
                                <md-field id="customer_zip" :class="getValidationClass('customer_zip')">
                                    <label for="customer_zip">Customer Zip</label>
                                    <md-input v-model="form.customer_zip"
                                              :required="form.customer_country === 'United States'"
                                              :disabled="executing_add"
                                              name="customer_zip"></md-input>
                                    <span class="md-error" v-if="!$v.form.customer_zip.customer_zip">Required and should contains only numeric values</span>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card style="flex: 1; margin-top: 10px">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Phone Number(s) to Port
                    </md-card-header>
                    <md-card-content style="padding-block-end: 30px">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item" style="padding: 10px">
                                <md-field id="phone_numbers" :class="getValidationClass('phone_numbers')">
                                    <label for="phone_numbers">Phone Number(s) to Port</label>
                                    <md-textarea
                                            :disabled="executing_add"
                                            v-model="form.phone_numbers"
                                            required
                                    ></md-textarea>
                                    <span class="md-error" v-if="!$v.form.phone_numbers.required">At least one phone number is required</span>
                                    <span class="md-error" v-else-if="!$v.form.phone_numbers.phonenumbers_list">Should contains only phone numbers in E.164 format starting with "1" and split by spaces or commas</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-size-50" id="file" :class="getValidationClass('file')">
                                <label for="file"
                                       :class="!$v.form.file.file && this.submitted ? 'error_label' : 'normal_label'">Letter
                                    of Authorization
                                    *</label>
                                <el-upload
                                        action=""
                                        style="padding: 3px"
                                        :on-preview="previewFile"
                                        :disabled="executing_add"
                                        :auto-upload="false"
                                        :on-remove="onFileRemove"
                                        :on-change="onFileChange">
                                    <i class="el-icon-upload"></i>
                                    <el-button size="medium" type="primary">Upload Letter of Authorization</el-button>
                                    <div class="el-upload__tip" slot="tip" style="padding-left: 15px"></div>
                                </el-upload>
                                <span class="md-error" style="font-size: 12px; color: #ff1744"
                                      v-if="!$v.form.file.file && this.submitted">Letter of Authorization is required</span>
                            </div>
                            <div class="md-layout-item md-size-50" id="requested_foc_date"
                                 :class="getValidationClass('requested_foc_date')">
                                <div style="display: grid">
                                    <label for="requested_foc_date"
                                           :class="((!$v.form.requested_foc_date.required || !$v.form.requested_foc_date.requested_foc_date) && this.submitted) ? 'error_label' : 'normal_label'">Requested
                                        Port Date *</label>
                                    <el-date-picker
                                            v-model="form.requested_foc_date"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            :disabled="executing_add"
                                            placeholder="Requested Port Date"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                    <span class="md-error" style="font-size: 12px; color: #ff1744"
                                          v-if="!$v.form.requested_foc_date.required && this.submitted">Requested Port Date is required</span>
                                    <span class="md-error" style="font-size: 12px; color: #ff1744"
                                          v-else-if="!$v.form.requested_foc_date.requested_foc_date && this.submitted">Requested Port Date should be at least {{ MIN_FOC_DATE }} days later than today</span>
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card style="flex: 1; margin-top: 10px">
                    <md-card-header style="background-color: rgb(244, 244, 244); font-size: 16px;">Comments
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item" style="padding-top: 10px;">
                                <md-field id="comment" >
                                    <label for="comment">Comments</label>
                                    <md-textarea
                                            :disabled="executing_add"
                                            v-model="form.comment"
                                    ></md-textarea>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </form>
        </md-dialog-content>
        <md-dialog-actions class="md-layout" style="margin: 5px">
            <el-button
                    class="md-size-25 md-layout-item"
                    :disabled="executing_add"
                    @click="updateIsCreating"
                    type="danger"
            >Cancel
            </el-button>
            <el-button
                    class="md-size-25 md-layout-item"
                    :loading="executing_add"
                    @click="createOrder"
                    type="success"
            >Create
            </el-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import {mapState} from "vuex";
    import {validationMixin} from 'vuelidate';
    import {
        required,
        numeric
    } from 'vuelidate/lib/validators';
    import {
        alpha_spaces,
        alpha_num_spaces,
        spid,
        email,
        phonenumber,
        phonenumbers_list
    } from '../utils/validators';
    import { MIN_FOC_DATE } from '../utils/constants';

    export default {
        name: "OrderCreateView",
        mixins: [validationMixin],
        props: ['show_create_order'],
        data() {
            return {
                pon_tooltip_disabled: false,
                psne_tooltip_disabled: false,
                btn_tooltip_disabled: false,
                form: {
                    name: '',
                    comment: '',
                    entity_id: (this.$store.state.auth.user.entity.length === 1) ? this.$store.state.auth.user.entity[0].id : null,
                    new_entity_id: '',
                    port_status_notification_email: '',
                    billing_telephone_number: '',
                    phone_numbers: '',
                    requested_foc_date: null,
                    customer_name: '',
                    customer_country: 'United States',
                    customer_street1: '',
                    customer_street2: '',
                    customer_city: '',
                    customer_state: '',
                    customer_zip: '',
                    file: null,
                },
                submitted: false,
                uploaded_file: [],
                pickerOptions: {
                    disabledDate(time) {
                        let firstAvailableDate = new Date();
                        firstAvailableDate.setDate(firstAvailableDate.getDate() + MIN_FOC_DATE);
                        return time.getTime() < firstAvailableDate;
                    },
                }
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    alpha_num_spaces
                },
                port_status_notification_email: {
                  email
                },
                entity_id: {
                    required
                },
                new_entity_id: {
                    required,
                    spid
                },
                customer_name: {
                    required,
                    alpha_spaces
                },
                customer_country: {
                    required
                },
                billing_telephone_number: {
                    required,
                    phonenumber
                },
                customer_street1: {
                    required,
                    alpha_num_spaces
                },
                customer_street2: {
                    customer_street2: function (value) {
                        if (!value) return true;
                        return alpha_num_spaces(value)
                    }
                },
                customer_city: {
                    required,
                    alpha_spaces
                },
                customer_state: {
                    customer_state: function (value, vm) {
                        if (vm.customer_country === "United States") {
                            return value && alpha_spaces(value)
                        }
                        else {
                            return true;
                        }
                    }
                },
                customer_zip: {
                    customer_state: function (value, vm) {
                        if (vm.customer_country === "United States") {
                            return value && numeric(value)
                        }
                        else {
                            return true;
                        }
                    }
                },
                phone_numbers: {
                    required,
                    phonenumbers_list
                },
                file: {
                    file: function () {
                        return this.form.file || this.old_file_used || this.uploaded_file.length !== 0;
                    }
                },
                requested_foc_date: {
                    required,
                    requested_foc_date: function (value) {
                        let firstAvailableDate = new Date();
                        firstAvailableDate.setDate(firstAvailableDate.getDate() + MIN_FOC_DATE);
                        return new Date(value) >= firstAvailableDate;
                    }
                }
            }
        },
        methods: {
            getValidationClass(fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            onFileRemove() {
                this.form.file = null
                this.uploaded_file = []
                this.$v.$touch()
            },
            previewFile() {
                window.open(this.uploaded_file[0].url, "_blank");
            },
            onFileChange(file) {
                this.form.file = file;
                this.uploaded_file = [{name: file.name, url: URL.createObjectURL(file.raw)}]
            },
            updateIsCreating: function () {
                this.$emit('update:show_create_order', !this.show_create_order)
                this.clearForm();
            },
            createOrder() {
                this.submitted = true;

                this.$v.$touch()
                if (this.$v.$invalid) return

                let data = new FormData();
                data.append('user_id', this.user.id);
                data.append('entity_id', this.form.entity_id);
                data.append('new_entity', this.form.new_entity_id);
                data.append('port_status_notification_email', this.form.port_status_notification_email);
                data.append('name', this.form.name.trim());
                data.append('BTN', this.form.billing_telephone_number);
                data.append('phone_numbers', this.form.phone_numbers);
                data.append('requested_foc_date', this.form.requested_foc_date);
                data.append('customer_name', this.form.customer_name.trim());
                data.append('customer_country', this.form.customer_country.trim());
                data.append('customer_street1', this.form.customer_street1.trim());
                data.append('customer_street2', this.form.customer_street2.trim());
                data.append('customer_city', this.form.customer_city.trim());
                data.append('customer_state', this.form.customer_state.trim());
                data.append('customer_zip', this.form.customer_zip.trim());
                data.append('file', this.form.file.raw, this.form.file.name);
                data.append('comments', this.form.comment.trim());
                this.$store.dispatch('orders/addOrder', data)
            },
            clearForm() {
                this.form = {
                    name: '',
                    entity_id: null,
                    new_entity_id: '',
                    port_status_notification_email: '',
                    BTN: '',
                    phone_numbers: '',
                    requested_foc_date: null,
                    customer_name: '',
                    customer_country: 'United States',
                    customer_street1: '',
                    customer_street2: '',
                    customer_city: '',
                    customer_state: '',
                    customer_zip: '',
                    file: null,
                    comment: ''
                }
                this.uploaded_file = [];
                this.submitted = false;
                this.$v.$reset()
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                countries: state => state.autocomplete.countries,
                executing_add: state => state.orders.executing_add,
                notification: state => state.orders.notification,
                show_notification: state => state.orders.show_notification,
            }),
        },
        watch: {
            executing_add: function (newVal, oldVal) {
                if (newVal === false && oldVal === true && this.notification.type === 'success') {
                    this.updateIsCreating()
                    this.clearForm()
                }
            },
        },
    }
</script>
<style>
</style>
<style scoped>
    .md-dialog {
        min-width: 70%;
        max-width: 95%;
    }

    .md-dialog /deep/ .md-dialog-container {
        transform: none;
    }

    .md-dialog /deep/ .md-dialog-content {
        padding: 5px;
    }
    .md-card-content:last-of-type {
         padding-bottom: 10px !important;
    }
    .md-list-item {
        height: 65px;
    }

    form {
        padding: 10px;
    }

    .el-input /deep/ .el-input__inner {
        border-color: gray
    }

    .el-input /deep/ .el-input__prefix {
        color: gray
    }

    .error_label {
        color: rgb(255, 23, 68);
        font-size: 12px;
    }

    .normal_label {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;
    }

    button {
        font-weight: 500;
    }
</style>
